import * as React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { window, isProduction } from './globals';

/**
 * Sets up Bugnsag, for error reporting.
 */
export default function setupBugsnag(): void {
  if (window.bugsnag?.enabled) {
    //  Setup Bugsnag
    window.bugsnagClient = Bugsnag.start({
      apiKey: window.bugsnag.frontend_key,
      plugins: [
        new BugsnagPluginReact(React),
      ],
      releaseStage: isProduction
        ? 'production'
        : 'development',
      appVersion: isProduction ? window.fossa_version : window.fossa_revision,
    });

    //  Set user (if they exist)
    if (window.user) {
      Bugsnag.setUser(window.user.id as unknown as string);
      Bugsnag.addMetadata('user', 'organizationId', window.user.organizationId);
    }
  }
}
